var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.794 11.264a5.44 5.44 0 0 0 3.03-.922l3.137 3.14a.653.653 0 0 0 .91 0l.61-.61a.654.654 0 0 0 0-.912l-3.147-3.129c.578-.868.92-1.907.92-3.032 0-3.012-2.451-5.466-5.46-5.466S.334 2.787.334 5.8a5.465 5.465 0 0 0 5.46 5.465m0-8.787c1.831 0 3.32 1.49 3.32 3.322a3.323 3.323 0 0 1-3.32 3.322c-1.83 0-3.32-1.49-3.32-3.322a3.324 3.324 0 0 1 3.32-3.322"
  })));
};
export default SvgSearch;